import instance from "api/globalaxios";

export async function download_MIS_Report(startDate, endDate) {
  return instance({
    method: 'get',
    url: `api/orixmisreport/?` + ((startDate && endDate) ? `start_date=${startDate}&end_date=${endDate}` : ''),
    responseType: 'blob'
  })
}

export async function triggerOrixEmail(type, email='') {
  return instance({
    method: 'post',
    url: `api/trigger_orix_email/?type=${type}&email=${email}`,
  })
}